import { useTranslation } from "next-i18next";
import Text from "ab-text";

import EscapadaDetail from "./EscapadaDetail";

import "./ab-detalles-dos.scss";

const DetallesDos = ({ detalles, color = "", i18n }) => {
  const { t } = useTranslation("common", { i18n });
  return (
    <div className={`ab-detalles-dos ${color}`}>
      <div className="left">
        <Text element="h2">{t("queIncluye")}</Text>
      </div>
      <div className="right">
        {detalles?.map((itm, index) => (
          <EscapadaDetail itm={itm} isOpen={index == 0} />
        ))}
      </div>
    </div>
  );
};

export default DetallesDos;
